import { ReactNode } from "react";
import { create } from "zustand";

export interface ProfileEditFooterEntry {
  key: string;
  node: ReactNode;
}

interface ProfileEditFooterState {
  entry: ProfileEditFooterEntry | null;
  setFooter: (entry: ProfileEditFooterEntry | null) => void;
  clearFooter: () => void;
}

export const useProfileEditFooterStore = create<ProfileEditFooterState>((set) => ({
  entry: null,
  setFooter: (entry) => set({ entry }),
  clearFooter: () => set({ entry: null }),
}));


